import { organAcceptanceCriteriaFetcher } from './apis/cases';
import { clinicalDataFetcher } from '@/api/apis/cases/clinical-data';
import { caseApiFetcher } from './apis/case';
import {
  geoApiFetcher,
  hospitalApiFetcher,
  hubApiFetcher,
  txCentersApiFetcher,
  airportApiFetcher,
  regionsApiFetcher,
  txCenterProvidersApiFetcher,
  partnerProvidersApiFetcher,
  homeLocationApiFetcher,
} from './apis/facilities';
import { customerApiFetcher } from './apis/customer';
import { userApiFetcher } from './apis/user';
import { filesApiFetcher } from './apis/files';
import { resourceApiFetcher } from './apis/resources';
import { resourceReleaseNotesApiFetcher } from './apis/resources/release-notes';
import { scheduleApiFetcher } from './apis/resources/schedule';
import { missionPlannerApiFetcher } from './apis/mission-planner';
import { missionPlannerDistanceFetchers } from './apis/mission-planner-distance';
import { orchestratorApiFetcher } from './apis/orchestrator';
import { routeApiFetcher } from './apis/route';
import { quoteApiFetcher } from './apis/quote';
import { communicationApiFetcher } from './apis/communication';
import { chatApiFetcher } from './apis/chat';
import { hereMapsFetcher } from './apis/here-maps';
import { trialsApiFetchers } from './apis/facilities/trial-programs';
import { personalizationFetcher } from '@/api/apis/communication/personalization';
import { releaseNotesApiFetcher } from './apis/release-notes';
import { composerApiFetcher } from './apis/composer';
import { multiSuggestApiFetcher } from './apis/multi-suggest';
import { driveServiceFetchers } from './apis/drive-service';
import { opoApiFetcher } from './apis/opo';
import {
  opobffCaseApiFetcher,
  opobffContactApiFetcher,
  opobffHospitalApiFetcher,
  opobffOrganizationApiFetcher,
  opobffUsersApiFetcher,
  opobffReleaseNotesApiFetcher,
} from './apis/opobff';
import { offerApiFetcher } from './apis/offers';
import { donorSummaryFetcher } from './apis/offers/donor-summary';

export const api = {
  geo: geoApiFetcher,
  composer: composerApiFetcher,
  user: userApiFetcher,
  case: caseApiFetcher,
  clinicalData: clinicalDataFetcher,
  organAcceptanceCriteria: organAcceptanceCriteriaFetcher,
  customer: customerApiFetcher,
  hospital: hospitalApiFetcher,
  opo: opoApiFetcher,
  hub: hubApiFetcher,
  files: filesApiFetcher,
  resource: resourceApiFetcher,
  resourceReleaseNotes: resourceReleaseNotesApiFetcher,
  schedule: scheduleApiFetcher,
  txcenter: txCentersApiFetcher,
  txcenterprovider: txCenterProvidersApiFetcher,
  partnerprovider: partnerProvidersApiFetcher,
  airports: airportApiFetcher,
  homelocation: homeLocationApiFetcher,
  missionPlanner: missionPlannerApiFetcher,
  missionPlannerDistance: missionPlannerDistanceFetchers,
  orchestrator: orchestratorApiFetcher,
  regions: regionsApiFetcher,
  route: routeApiFetcher,
  quote: quoteApiFetcher,
  communication: communicationApiFetcher,
  chat: chatApiFetcher,
  personalization: personalizationFetcher,
  hereMaps: hereMapsFetcher,
  trials: trialsApiFetchers,
  releaseNotes: releaseNotesApiFetcher,
  multiSuggest: multiSuggestApiFetcher,
  driveService: driveServiceFetchers,
  opobffCase: opobffCaseApiFetcher,
  opobffContact: opobffContactApiFetcher,
  opobffHospital: opobffHospitalApiFetcher,
  opobffOrganization: opobffOrganizationApiFetcher,
  opobffUsers: opobffUsersApiFetcher,
  offer: offerApiFetcher,
  donorSummary: donorSummaryFetcher,
  opobffReleaseNotes: opobffReleaseNotesApiFetcher,
};
